import React from 'react'

const Footer = () => {
    return (
        <footer className="bg-info d-flex justify-content-center align-item-center text-white py-3">
            <p className="m-0">This is footer by Ali Chaudhary</p>
        </footer>
    )
}

export default Footer
